/* GyaanStore search helpers.
   Keeps a mic tap from closing the header search modal, makes the close (X) a
   reliable tap target, and hides the results-page mic while the header search
   modal is open.

   v2 change: removed the 0/80/240/600ms reopen-timer cascade that caused the
   modal to flicker open/closed on slower devices. A single synchronous reopen
   plus stopPropagation at the mic source (see header-search.liquid) is enough. */
(function () {
  function syncHeaderSearchState() {
    var isOpen = !!document.querySelector('.header__search details[open]');
    document.body.classList.toggle('gs-header-search-open', isOpen);
  }

  function keepOpenFromMic(target) {
    var button = target && target.closest ? target.closest('.header__search .gs-voice-search-button') : null;
    if (!button) return false;

    var details = button.closest('details');
    var input = details ? details.querySelector('input[type="search"][name="q"]') : null;

    // Re-assert the modal as OPEN now AND a couple of ticks later. Starting voice recognition
    // moves focus, which tripped Dawn's focus-out close and shut the search the moment the mic
    // was tapped. Re-opening after those events fire keeps the search panel up.
    function reopen() {
      if (details && !details.open) details.setAttribute('open', '');
      if (input) input.focus({ preventScroll: true });
      syncHeaderSearchState();
    }
    reopen();
    setTimeout(reopen, 0);
    setTimeout(reopen, 150);
    return true;
  }

  function closeHeaderSearch(target) {
    var closeButton = target && target.closest ? target.closest('.header__search .search-modal__close-button') : null;
    if (!closeButton) return false;

    var details = closeButton.closest('details');
    var summary = details ? details.querySelector('summary') : null;

    if (details) details.removeAttribute('open');
    if (summary) summary.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('gs-header-search-open');

    if (summary) summary.focus({ preventScroll: true });
    return true;
  }

  ['pointerdown', 'click', 'touchstart'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      var target = event.target;

      if (target && target.closest && target.closest('.header__search .search-modal__close-button')) {
        // Block the tap from reaching the header behind (the cart icon), but only CLOSE on the
        // actual click. Closing on touchstart/pointerdown removed the modal too early, so the
        // follow-up click landed on the now-revealed cart icon — that was the "X acts like a
        // double tap and opens the cart" bug. Suppressing all three + closing only on click
        // keeps the tap fully contained on the X button.
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();
        if (eventName === 'click') closeHeaderSearch(target);
        return;
      }

      keepOpenFromMic(target);
      syncHeaderSearchState();
    }, true);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncHeaderSearchState();
    var headerSearch = document.querySelector('.header__search details');
    if (headerSearch && window.MutationObserver) {
      new MutationObserver(syncHeaderSearchState).observe(headerSearch, { attributes: true, attributeFilter: ['open'] });
    }
  });

  document.addEventListener('shopify:section:load', syncHeaderSearchState);
})();
